<template>
    <div class='page'>
        <!-- 搜索 -->
        <el-form v-if='isSearch' :model='queryForm' ref='form' label-width='80px' :inline='true' size='small'
                 class='query-form' @submit.native.prevent>
            <el-form-item label="姓名">
                <el-input style='width: 177px;' v-model="queryForm.agentName"></el-input>
            </el-form-item>
            <el-form-item label="电话">
                <el-input style='width: 177px;' v-model="queryForm.agentMobile"></el-input>
            </el-form-item>
            <el-form-item
                label='省份'
                prop='provinceId'
            >
                <el-select
                    style='width:177px'
                    v-model='queryForm.provinceId'
                    size='small'
                    placeholder='请选择省份'
                >
                    <el-option
                        v-for='item in provinceIdList'
                        :key='item.id'
                        :label='item.name'
                        :value='item.id'
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                label='城市'
            >
                <el-select
                    style='width:177px'
                    v-model='queryForm.cityId'
                    size='small'
                    placeholder='请选择城市'
                >
                    <el-option
                        v-for='item in cityIdList2'
                        :key='item.id'
                        :label='item.name'
                        :value='item.id'
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                label='区县'
                prop='areaId'
            >
                <el-select
                    style='width:177px'
                    v-model='queryForm.areaId'
                    size='small'
                    placeholder='请选择区县'
                >
                    <el-option
                        v-for='item in areaIdList2'
                        :key='item.id'
                        :label='item.name'
                        :value='item.id'
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                label='社区'
                prop='streetId'
            >
                <el-select
                    style='width:177px'
                    v-model='queryForm.streetId'
                    size='small'
                    placeholder='请选择社区'
                >
                    <el-option
                        v-for='item in streetIdList2'
                        :key='item.id'
                        :label='item.name'
                        :value='item.id'
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属用户">
                <GridSelectU style="width: 177px;" labelName="userName" title="选择用户"
                             labelValue="id" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                             @getValue="getSeachValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                </GridSelectU>
            </el-form-item>
            <el-form-item label="审核状态">
                <el-select style='width: 177px;' v-model="queryForm.status" placeholder="请选择" clearable size="small">
                    <el-option v-for="item in auditStatus" :key="item.key" :value="item.key" :label="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size='small' type='primary' icon='el-icon-search' @click='getMppAgentList'>查询</el-button>
                <el-button size='small' icon='el-icon-refresh' @click='resetDialog'>重置</el-button>
            </el-form-item>
        </el-form>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'>
                    <el-button
                        type='primary'
                        size='small'
                        icon='el-icon-plus'
                        @click='addMppAgent'
                    >新建
                    </el-button>
                    <el-button
                        type='warning'
                        plain
                        size='small'
                        icon='el-icon-edit'
                        :disabled='multipleSelection.length != 1'
                        @click='editMppAgent(null)'
                    >修改
                    </el-button>
                    <el-button
                        type='danger'
                        plain
                        size='small'
                        icon='el-icon-delete'
                        :disabled='multipleSelection.length <= 0'
                        @click='deleteMppAgent(null)'
                    >删除
                    </el-button>
                    <el-button
                        type='primary'
                        plain
                        size='small'
                        @click='getAgenrlevel()'
                    >代理级别
                    </el-button>
                </div>

                <div class='icon-group'>
                    <el-upload v-if='this.isImportDate'
                               class='upload-demo'
                               action='#'
                               :http-request='upload'
                               :show-file-list='true'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title='搜索'
                        class='icon-box'
                        @click='search'
                    >
          <Icon color='#606266'>
            <Search />
          </Icon>
        </span>
                    <span
                        class='icon-box'
                        @click='refreshMppAgentList'
                    >
          <Icon color='#606266'>
            <Refresh />
          </Icon>
        </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                height='100%'
                :data='mppAgentList'
                row-key='id'
                border
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change='handleSelectionChange'
                size='small'
            >
                <el-table-column
                    align='center'
                    type='selection'
                    width='60'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='agentHeader'
                    label='代理人头像'
                    width='180'
                >
                    <template scope='scope'>
                        <div v-if='scope.row.agentHeader'>
                            <el-image @click='updateSrcList(scope.row.agentHeader)' style="width: 60px; height: 60px"
                                      :src="scope.row.agentHeader" :preview-src-list="srcList"> </el-image>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='levelId'
                    label='代理级别'
                    width='180'
                >
                    <template scope='scope'>
                        <div>{{ getLevelString(scope.row.levelId) }}</div>
                    </template>

                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='levelId'
                    label='代理商信息'
                    width='180'
                >
                    <template scope='scope'>
                        <div style="text-align: left">姓名：{{ scope.row.agentName }}</div>
                        <div style="text-align: left">手机：{{ scope.row.agentMobile }}</div>
                    </template>

                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='left'
                    label='用户'
                    width='180'
                >
                    <template slot-scope='scope'>
                        <div v-if="scope.row.mppUser">
                            <div style="text-align: left">账号：{{ scope.row.mppUser.userName }}</div>
                            <div style="text-align: left">手机：{{ scope.row.mppUser.userMobile }}</div>
                            <div style="text-align: left">昵称：{{ scope.row.mppUser.userNickname }}</div>
                            <div style="text-align: left">姓名：{{ scope.row.mppUser.userRealname }}</div>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='status'
                    label='代理状态'
                    width='180'
                >
                    <template scope='scope'>
                        <div>{{ getStatusString(scope.row.status) }}</div>
                        <div v-if="scope.row.status == 3">原因：{{ scope.row.refuseReason }}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="idFrontSide" label="身份证正面" width="180">
                    <template slot-scope="scope">
                        <div v-if='scope.row.idFrontSide'>
                            <el-image @click='updateSrcList(scope.row.idFrontSide)' style="width: 60px; height: 60px"
                                      :src="scope.row.idFrontSide" :preview-src-list="srcList"> </el-image>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="idBackSide" label="身份证反面" width="180">
                    <template slot-scope="scope">
                        <div v-if='scope.row.idBackSide'>
                            <el-image @click='updateSrcList(scope.row.idBackSide)' style="width: 60px; height: 60px"
                                      :src="scope.row.idBackSide" :preview-src-list="srcList"> </el-image>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip='true'-->
<!--                    align='center'-->
<!--                    label='国家'-->
<!--                    width='180'-->
<!--                >-->
<!--                    <div>中国</div>-->
<!--                </el-table-column>-->
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='province.name'
                    label='省份'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='city.name'
                    label='城市'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='area.name'
                    label='区县'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='street.name'
                    label='社区'
                    width='180'
                ></el-table-column>
				<el-table-column
				  :show-overflow-tooltip="true"
				  align="center"
				  prop="createTime"
				  label="创建时间"
				  width="180"
				> </el-table-column>
                <el-table-column
                    fixed='right'
                    align='center'
                    label='操作'
                    width='300'
                >
                    <template slot-scope='scop'>
                        <div class='operation'>
                            <div @click=' auditMppAgent(scop.row)' v-if='scop.row.status == 1'>
                                <el-button type='primary' size='small'>审核</el-button>
                            </div>
                            <div @click='checkMppAgent(scop.row.id)'>
                                <Icon size='16'>
                                    <Eye24Regular />
                                </Icon>
                                <span class='operation-label'>查看</span>
                            </div>
                            <div @click='editMppAgent(scop.row.id)'>
                                <Icon size='16'>
                                    <Edit24Regular />
                                </Icon>
                                <span class='operation-label'>修改</span>
                            </div>
                            <div @click='deleteMppAgent(scop.row.id)'>
                                <Icon size='16' style='color: red'>
                                    <Delete24Regular />
                                </Icon>
                                <span class='operation-label' style='color: red'>删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='sizeChange'
                    @current-change='currentChange'
                    :current-page.sync='currentPage'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    :total='totalNum'
                    background
                    :pager-count='7'
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title='mppAgentStates[mppAgentState]'
                :visible.sync='showDialog'
                width='60%'
                @close='closeDialog'
            >
                <div>
                    <el-form
                        :model='mppAgent'
                        ref='mppAgentForm'
                        :rules='rules'
                        label-width='120px'
                        :inline='true'
                        size='small'
                    >
                        <el-form-item label="代理商名称" prop="agentName">
                            <el-input placeholder="请输入代理商名称" style='width:200px' size="small" v-model="mppAgent.agentName" :disabled="mppAgentState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="代理商号码" prop="agentMobile">
                            <el-input placeholder="请输入代理商号码" style='width:200px' size="small" v-model="mppAgent.agentMobile" :disabled="mppAgentState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="是否冻结收益" prop="isFreezeIncome">
                            <el-select v-model="mppAgent.isFreezeIncome" placeholder="请选择是否冻结收益" style='width:200px' size="small" :disabled="mppAgentState == 'check'">
                                <el-option :value="1" label="是"/>
                                <el-option :value="0" label="否"/>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='代理级别'
                            prop='levelId'
                        >
                            <el-select
                                style='width:200px'
                                v-model='mppAgent.levelId'
                                size='small'
                                placeholder='请选择'
                                :disabled="mppAgentState == 'check'"
                            >
                                <el-option
                                    v-for='item in agentLevel'
                                    :key='item.key'
                                    :label='item.value'
                                    :value='item.key'
                                ></el-option>
                            </el-select>
                        </el-form-item>


                        <!--          <el-form-item-->
                        <!--            label="用户ID"-->
                        <!--            prop="userId"-->
                        <!--          >-->
                        <!--            <el-input-->
                        <!--              style='width: 105.7px'-->
                        <!--              size="small"-->
                        <!--              v-model="mppAgent.userId"-->
                        <!--              :disabled="mppAgentState == 'check'"-->
                        <!--            ></el-input>-->
                        <!--            <el-button-->
                        <!--              style='width: 60px;margin-left: 10px'-->
                        <!--              type="primary"-->
                        <!--              @click='DeptUser(scop.row)'-->
                        <!--            >选择</el-button>-->
                        <!--          </el-form-item>-->
                        <el-form-item
                            v-if='1'
                            label='用户'
                            prop='userId'
                        >
                            <GridSelect
                                :disabled="mppAgentState == 'check'"
                                style='width:200px'
                                title='选择用户'
                                labelName='userName'
                                labelValue='id'
                                :value='mppAgent.userId'
                                :limit='1'
                                size='small'
                                placeholder='请选择用户'
                                @getValue='(value) => {mppAgent.userId = value}'
                                :columns="USER_code"
                                :searchs="USER_search"
                                dataListUrl='/mpp/user/findList'
                                entityBeanName='mppUser'
                                queryEntityUrl='/mpp/user/get'
                            >
                            </GridSelect>
                        </el-form-item>

                        <!--          <el-form-item-->
                        <!--            label="代理状态"-->
                        <!--            prop="status"-->
                        <!--          >-->
                        <!--            <el-input-->
                        <!--              size="small"-->
                        <!--              v-model="mppAgent.status"-->
                        <!--              :disabled="true"-->
                        <!--            ></el-input>-->
                        <!--          </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label='国家'-->
<!--                            prop='countryId'-->
<!--                        >-->
<!--                            <el-select-->
<!--                                style='width:177px'-->
<!--                                v-model='mppAgent.countryId'-->
<!--                                size='small'-->
<!--                                placeholder='请选择国家'-->
<!--                                :disabled="mppAgentState == 'check'"-->
<!--                            >-->
<!--                                <el-option-->
<!--                                    v-for='item in treeData'-->
<!--                                    :key='item.id'-->
<!--                                    :label='item.areaName'-->
<!--                                    :value='item.id'-->
<!--                                ></el-option>-->
<!--                            </el-select>-->
<!--                        </el-form-item>-->
                        <el-form-item
                            label='省份'
                            prop='provinceId'
                            v-if='(agentLevelIndex === 1 && showProvince === 1) || (agentLevelIndex === 2 && showCity === 1) || (agentLevelIndex === 3 && showArea === 1) || (agentLevelIndex === 4 && showArea === 1)'
                        >
                            <el-select
                                style='width:200px'
                                v-model='mppAgent.provinceId'
                                size='small'
                                placeholder='请选择省份'
                                :disabled="mppAgentState == 'check'"
                            >
                                <el-option
                                    v-for='item in provinceIdList'
                                    :key='item.id'
                                    :label='item.name'
                                    :value='item.id'
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='城市'
                            prop='cityId'
                            v-if='(agentLevelIndex === 2 && showCity === 1) || (agentLevelIndex === 3 && showArea === 1) || (agentLevelIndex === 4 && showCity === 1)'
                        >
                            <el-select
                                style='width:200px'
                                v-model='mppAgent.cityId'
                                size='small'
                                placeholder='请选择城市'
                                :disabled="mppAgentState == 'check'"
                            >
                                <el-option
                                    v-for='item in cityIdList'
                                    :key='item.id'
                                    :label='item.name'
                                    :value='item.id'
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='区县'
                            prop='areaId'
                            v-if=' (agentLevelIndex === 3 && showArea === 1) || (agentLevelIndex === 4 && showCity === 1)'
                        >
                            <el-select
                                style='width:200px'
                                v-model='mppAgent.areaId'
                                size='small'
                                placeholder='请选择区县'
                                :disabled="mppAgentState == 'check'"
                            >
                                <el-option
                                    v-for='item in areaIdList'
                                    :key='item.id'
                                    :label='item.name'
                                    :value='item.id'
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='社区'
                            prop='streetId'
                            v-if=' (agentLevelIndex === 4 && showArea === 1)'
                        >
                            <el-select
                                style='width:200px'
                                v-model='mppAgent.streetId'
                                size='small'
                                placeholder='请选择社区'
                                :disabled="mppAgentState == 'check'"
                            >
                                <el-option
                                    v-for='item in streetIdList'
                                    :key='item.id'
                                    :label='item.name'
                                    :value='item.id'
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="代理商头像" prop="agentHeader">
                            <div style="display:flex;width: 200px;">
                                <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                           :disabled="mppAgentState == 'check'" class="avatar-uploader" :show-file-list="false"
                                           :http-request="uploadImage">
                                    <img v-if="mppAgent.agentHeader" :src="mppAgent.agentHeader" class="avatar" size="small" />
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(mppAgent.agentHeader)">查看</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="身份证正面" prop="idFrontSide">
                            <div style="display:flex;width: 200px;">
                                <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                           :disabled="mppAgentState == 'check'" class="avatar-uploader" :show-file-list="false"
                                           :http-request="uploadImage1">
                                    <img v-if="mppAgent.idFrontSide" :src="mppAgent.idFrontSide" class="avatar" size="small" />
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(mppAgent.idFrontSide)">查看</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="身份证反面" prop="idBackSide">
                            <div style="display:flex;width: 200px;">
                                <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                           :disabled="mppAgentState == 'check'" class="avatar-uploader" :show-file-list="false"
                                           :http-request="uploadImage2">
                                    <img v-if="mppAgent.idBackSide" :src="mppAgent.idBackSide" class="avatar" size="small" />
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(mppAgent.idBackSide)">查看</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="申请说明" prop="applyRemarks">
                            <el-input style='width: 200px' type='textarea' :rows="6" v-model='mppAgent.applyRemarks' :disabled="mppAgentState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item
                            label="签约状态"
                            prop="isSign"
                        >
                            <el-select
                                v-model="mppAgent.isSign"
                                size="small"
                                :disabled="mppAgentState == 'check'"
                                placeholder="请选择签约状态"
                                clearable
                                style="width: 200px"
                            >
                                <el-option label="未签约" :value="0"> </el-option>
                                <el-option label="已签约" :value="1"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="签名图片"
                            prop="signPic"
                        >
                            <div style="display:flex;width: 200px;">
                                <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                           class="avatar-uploader" :show-file-list="false" :disabled="mppAgentState == 'check'"
                                           :http-request="uploadImage11">
                                    <img v-if="mppAgent.signPic" :src="mppAgent.signPic" class="avatar" size="small" />
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(mppAgent.signPic)">查看</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item
                            label="合同地址"
                            prop="contractUrl"
                        >
                            <div style="display:flex;width: 200px;">
                                <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                           class="avatar-uploader" :show-file-list="false" :disabled="mppAgentState == 'check'"
                                           :http-request="uploadImage12">
                                    <img v-if="mppAgent.contractUrl" :src="mppAgent.contractUrl" class="avatar" size="small" />
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(mppAgent.contractUrl)">查看</el-button>
                            </div>
                        </el-form-item>
                    </el-form>
                    <el-image ref="images" v-show="false" @click='updateSrcList(imageSrc)' style="width: 60px; height: 60px"
                              :src="imageSrc" :preview-src-list="srcList"> </el-image>
                </div>

                <div
                    slot='footer'
                    class='flex justify-end'
                >
                    <el-button @click='closeDialog'>关闭</el-button>
                    <el-button
                        type='primary'
                        @click='submitForm'
                        v-if="mppAgentState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>

            <!--审核功能-->
            <el-dialog title='代理审核' :visible.sync='retreatDialogVisible' width='30%'
                       :before-close='handleCloseRetreat'>
                <el-form ref='retreatForm' :rules='retreatRules' size='small' :model='retreatForm' label-width='100px'>
                    <el-form-item label='申请说明：'>
                        <el-input style='width: 100%' type='textarea' v-model='applyRemarks' :disabled='true'></el-input>
                    </el-form-item>
                    <el-form-item label='是否同意：' prop='resource'>
                        <el-radio-group v-model='retreatForm.resource'>
                            <el-radio label='true-1'>同意付费代理(统计业绩)</el-radio>
                            <el-radio label='true-2'>同意免费代理</el-radio>
                            <el-radio label='false'>拒绝</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label='拒绝原因：' v-if="retreatForm.resource == 'false'" prop='desc'>
                        <el-input style='width: 100%' type='textarea' v-model='retreatForm.desc'></el-input>
                    </el-form-item>
                </el-form>
                <span slot='footer' class='dialog-footer'>
              <el-button @click='handleCloseRetreat'>取 消</el-button>
              <el-button type='primary' @click="retreatSuccess('retreatForm')">确 定</el-button>
          </span>
            </el-dialog>


        </div>

        <el-drawer
            title="代理级别"
            :visible.sync="showAgenrlevel"
            direction="rtl"
            size="60%"
            :destroy-on-close="true"
            :show-close="true"
            :wrapperClosable="true"
            @close="closeAgenrlevel"
        >
            <AgentLevel></AgentLevel>
        </el-drawer>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import RoleListTable from '@/components/organization/RoleListTable.vue';
import GridSelect from '@/components/gridselect';
import { UPLOAD_API, UPLOAD_PATH, USER, USER_SEARCH } from '@/utils/constant';
import AgentLevel from '@/views/organization/AgentLevel.vue';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import GridSelectU from '@/components/gridselect/index.vue';
export default {
    components: {
        GridSelectU, GridSelectLi,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        RoleListTable,
        GridSelect,
        AgentLevel
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetMppAgentList();
                this.getMppAgentList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetMppAgentList();
                this.getMppAgentList();
                this.$emit('resetCheckState');
            }
        },
        'mppAgent.levelId'(id) {
            for (let i = 0; i < this.agentLevel.length; i++) {
                if (this.agentLevel[i].key == id) {
                    this.agentLevelIndex = this.agentLevel[i].agentLevel;
                }
            }
        },

        //省
        // 'mppAgent.countryId'() {
        //     this.provinceIdList = this.treeData[0].children;
        // },
        //市
        'mppAgent.provinceId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getCity) {
                    this.mppAgent.cityId = '';
                    this.mppAgent.areaId = '';
                    this.mppAgent.streetId = '';
                } else {
                    this.getCity = !this.getCity;
                }
                this.getAddress(2,id)
            }, 5);
        },
        //区
        'mppAgent.cityId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getArea) {
                    this.mppAgent.areaId = '';
                    this.mppAgent.streetId = '';
                } else {
                    this.getArea = !this.getArea;
                }
                this.getAddress(3,id)
            }, 10);
        },
        //社区
        'mppAgent.areaId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.street) {
                    this.mppAgent.streetId = '';
                } else {
                    this.street = !this.street;
                }
                this.getAddress(4,id)
            }, 15);
        },
        //市
        'queryForm.provinceId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getCity2) {
                    this.queryForm.cityId = '';
                    this.queryForm.areaId = '';
                    this.queryForm.streetId = '';
                } else {
                    this.getCity2 = !this.getCity2;
                }
                this.getAddress2(2,id)
            }, 5);
        },
        //区
        'queryForm.cityId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getArea2) {
                    this.queryForm.areaId = '';
                    this.queryForm.streetId = '';
                } else {
                    this.getArea2 = !this.getArea2;
                }
                this.getAddress2(3,id)
            }, 10);
        },
        //社区
        'queryForm.areaId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.street2) {
                    this.queryForm.streetId = '';
                } else {
                    this.street2 = !this.street2;
                }
                this.getAddress2(4,id)
            }, 15);
        },
    },
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            showProvince: 0,
            showCity: 0,
            showArea: 0,

            retreatDialogVisible: false,
            auditStatus: [],
            agentLevel: [],
            queryForm: {
                levelId: '', //等级ID
                userId: '', //用户ID
                status: '', //代理状态
                countryId: '', //国家ID
                provinceId: '', //省ID
                cityId: '', //市ID
                agentName: '',
                agentMobile: '',
                areaId: '' ,//县区ID
                streetId: '',
            },
            getCity2: false,//区别是不是get来的
            getArea2: false,//区别是不是get来的
            street2: false,
            cityIdList2: [], //市信息
            areaIdList2: [], //区信息
            streetIdList2: [],
            header: {
                token: localStorage.getItem('token')
            },
            action: UPLOAD_API + UPLOAD_PATH,
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            mppAgentState: 'add',
            mppAgentStates: {
                add: '新建代理',
                check: '查看代理',
                edit: '修改代理'
            },
            showAgenrlevel: false,
            multipleSelection: [],
            mppAgentList: [],
            mppAgent: {
                levelId: '', //等级ID
                userId: '', //用户ID
                status: '', //代理状态
                isFreezeIncome: '',// 是否冻结收益
                // countryId: '', //国家ID
                provinceId: '', //省ID
                cityId: '', //市ID
                areaId: '', //县区ID
                agentName: '',
                agentHeader: '',
                agentMobile: '',
                idFrontSide: '',
                idBackSide: '',
                streetId: '',
            },
            treeData: [], //获取的区域信息
            provinceIdList: [], //省信息
            cityIdList: [], //市信息
            areaIdList: [], //区信息
            streetIdList: [],
            getCity: false,//区别是不是get来的
            getArea: false,//区别是不是get来的
            street: false,
            agentLevelIndex: 0,
            btnLoading: false,
            rules: {
                levelId: [{ required: true, message: '等级ID不能为空', trigger: 'blur' }],
                userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }],
                // countryId: [{ required: true, message: '国家不能为空', trigger: 'blur' }],
                isFreezeIncome: [{ required: true, message: '是否冻结收益不能为空', trigger: 'blur' }],
                provinceId: [{ required: true, message: '省份区域不能为空', trigger: 'blur' }],
                cityId: [{ required: true, message: '城市区域不能为空', trigger: 'blur' }],
                areaId: [{ required: true, message: '区县级区域不能为空', trigger: 'blur' }],
                agentName: [{ required: true, message: '代理商名称不能为空', trigger: 'blur' }],
                agentHeader: [{ required: true, message: '代理商头像不能为空', trigger: 'blur' }],
                agentMobile: [{ required: true, message: '代理商号码不能为空', trigger: 'blur' }],
                idFrontSide: [{ required: true, message: '身份证正面照不能为空', trigger: 'blur' }],
                idBackSide: [{ required: true, message: '身份证反面照不能为空', trigger: 'blur' }],
                streetId: [{ required: true, message: '社区级区域不能为空', trigger: 'blur' }],
            },
            retreatRules: {
                resource: [{ required: true, message: '请选择是否同意', trigger: 'change' }],
                desc: [{ required: true, message: '请填写拒绝原因', trigger: 'blur' }]
            },
            retreatForm: {
                resource: '',
                desc: ''
            },
            auditId: '',// 申请人的id
            applyRemarks: '',// 申请人的说明

            srcList: [''],
            imageSrc: ''
        };
    },
    created() {
        this.getMppAgentList();
        this.getAgentLevel();
        this.getAuditStatus();
        this.getAddress(1);
    },
    methods: {
        DeptUser(dept) {
            this.currentDept = dept;
            setTimeout(() => {
                this.$refs.deptUser.init();
            }, 200);
        },
        updateSrcList(src){
            this.srcList[0] = src
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        //上传缩略图
        uploadImage11(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mppAgent.signPic = res.url;
                }
            });
        },
        uploadImage12(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mppAgent.contractUrl = res.url;
                }
            });
        },
        getImage(url){
            this.imageSrc = url;
            this.srcList[0] = url;
            this.$refs.images.showViewer = true;
        },
        // 获取对应地址
        getAddress(type, id=null) {
            get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.list) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 1){
                        this.provinceIdList = array
                    }else if(type == 2){
                        this.cityIdList = array
                    }else if(type == 3){
                        this.areaIdList = array
                    }else if(type == 4){
                        this.streetIdList = array
                    }
                }
            })
        },
        // 获取对应地址
        getAddress2(type, id=null) {
            get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.list) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 1){
                        this.provinceIdList = array
                    }else if(type == 2){
                        this.cityIdList2 = array
                    }else if(type == 3){
                        this.areaIdList2 = array
                    }else if(type == 4){
                        this.streetIdList2 = array
                    }
                }
            })
        },
        getSeachValueUser(value){
            this.queryForm.userId = value
        },
        //上传缩略图
        uploadImage(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mppAgent.agentHeader = res.url;
                }
            });
        },
        //上传缩略图
        uploadImage1(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mppAgent.idFrontSide = res.url;
                }
            });
        },
        beforeImageUpload(file){
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
        //上传缩略图
        uploadImage2(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.mppAgent.idBackSide = res.url;
                }
            });
        },
        getAgenrlevel(){
            this.showAgenrlevel = true;
        },
        closeAgenrlevel(){
            this.showAgenrlevel = false;
        },
        resetMppAgentList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.mppAgentList = [];
        },
        resetDialog() {
            this.mppAgentState = 'add';
            this.showDialog = false;
            this.queryForm = {
                levelId: '', //等级ID
                userId: '', //用户ID
                status: '', //代理状态
                countryId: '', //国家ID
                provinceId: '', //省ID
                cityId: '', //市ID
                areaId: '', //县区ID
                agentName: '',
                agentMobile: '',
                streetId: '',
            };
            this.getMppAgentList();
        },
        closeDialog() {
            this.showDialog = false;
            this.mppAgent = {
                levelId: '', //等级ID
                userId: '', //用户ID
                status: '', //代理状态
                isFreezeIncome: '',// 是否冻结收益
                // countryId: '', //国家ID
                provinceId: '', //省ID
                cityId: '', //市ID
                areaId: '', //县区ID
                agentName: '',
                agentHeader: '',
                agentMobile: '',
                idFrontSide: '',
                idBackSide: '',
                streetId: '',
            };
        },
        submitForm() {
            if (this.mppAgentState == 'add') {
                this.mppAgent.status = 1; //添加的代理默认为待审核状态
                this.$refs.mppAgentForm.validate((valid) => {
                    if (valid) {
                        post(`/mpp/mppagent/add`, { ...this.mppAgent }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppAgentList();
                                this.resetDialog();
                                this.getMppAgentList();
                            }
                        });
                    }
                });
            } else if (this.mppAgentState == 'edit') {
                this.$refs.mppAgentForm.validate((valid) => {
                    //get到的去除省市区对象
                    delete this.mppAgent.area;
                    delete this.mppAgent.city;
                    delete this.mppAgent.mppAgentLevel;
                    delete this.mppAgent.mppUser;
                    delete this.mppAgent.province;
                    delete this.mppAgent.street;

                    if (valid) {
                        post(`/mpp/mppagent/edit`, { ...this.mppAgent }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppAgentList();
                                this.resetDialog();
                                this.getMppAgentList();
                            }
                        });
                    }
                });
            }
        },
        addMppAgent() {
            this.showDialog = true;
            this.mppAgentState = 'add';
        },
        auditMppAgent(item) {
            this.retreatForm.desc = ''; // 清空之前的申请理由
            this.auditId = item.id;
            this.applyRemarks = item.applyRemarks;
            this.retreatDialogVisible = true;
        },
        checkMppAgent(mppAgentId) {
            this.currentMppAgentId = mppAgentId;

            this.getMppAgentById();
            this.showDialog = true;
            this.mppAgentState = 'check';
        },
        editMppAgent(mppAgentId) {
            if (mppAgentId) {
                this.currentMppAgentId = mppAgentId;
                this.getMppAgentById();
            } else {
                this.mppAgent = { ...this.mppAgent, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.mppAgentState = 'edit';
        },
        deleteMppAgent(mppAgentId) {
            let ids = '';
            if (mppAgentId) {
                ids = mppAgentId;
            } else {
                ids = this.multipleSelection.map((mppAgent) => mppAgent.id).join(',');
            }
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/mpp/mppagent/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetMppAgentList();
                            this.getMppAgentList();
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshMppAgentList() {
            this.resetMppAgentList();
            this.getMppAgentList();
        },
        getMppAgentList(query = {}) {
            this.loading = true;
            get(`/mpp/mppagent/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.mppAgentList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getMppAgentById() {
            get(`/mpp/mppagent/get`, { id: this.currentMppAgentId }).then((res) => {
                if (res.success) {
                    this.mppAgent = { ...this.mppAgent, ...res.mppAgent };
                    let array = [];
                    if(this.mppAgent.cityId){
                        array.push(this.mppAgent.provinceId)
                    }
                    if(this.mppAgent.areaId){
                        array.push(this.mppAgent.cityId)
                    }
                    if(this.mppAgent.streetId){
                        array.push(this.mppAgent.areaId)
                    }
                    if(array.length > 0){
                        array = array.join(",")
                    }else{
                        array = ""
                    }
                    console.log(array)
                    // this.initAddress(array)
                    this.getCity = true;
                    this.getArea = true;
                    this.street = true;
                }
            });
        },
        /**
         * 导出信息
         */
        exportMppAgentList() {
            //this.btnLoading = true;
            exprotExcel(`/mpp/mppagent/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/mpp/mppagent/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            importDate(`/mpp/mppagent/importData`, formData);
            this.refreshMppAgentList();
        },
        handleSelectionChange(value) {
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMppAgentList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMppAgentList();
        },
        getAuditStatus() {
            get('/mpp/utils/getEnum', { enumType: 'audit_status' }).then((res) => {
                if (res.success && res.code == 200) {
                    this.auditStatus = res.enumList;
                }
            });
        },
        getAgentLevel() {
            get(`/mpp/mppagentlevel/findAll`).then((res) => {
                if (res.success && res.code == 200) {
                    res.list.forEach((item) => {
                        this.agentLevel.push({
                            agentLevel: item.agentLevel,
                            key: item.id,
                            value: item.agentName
                        });

                        if(item.agentLevel === 1){
                            this.showProvince = item.showSelect
                        } else if(item.agentLevel === 2){
                            this.showCity = item.showSelect
                        } else if(item.agentLevel === 3){
                            this.showArea = item.showSelect
                        }
                    });
                }
            });
        },
        getLevelString(key) {
            for (const index in this.agentLevel) {
                if (this.agentLevel[index].key == key) {
                    return this.agentLevel[index].value;
                }
            }
        },
        getStatusString(key) {
            for (const index in this.auditStatus) {
                if (this.auditStatus[index].key == key) {
                    return this.auditStatus[index].value;
                }
            }
        },
        // 审核取消按钮
        handleCloseRetreat() {
            this.retreatDialogVisible = false;
            this.auditId = '';//关闭后清除点击的id
            this.applyRemarks = ''; //关闭后清除申请人的说明
            this.retreatForm.resource = '';//关闭后把选择的按钮置空
            this.retreatForm.desc = '';//关闭后把拒绝利用清空
        },
        //审核确认按钮
        retreatSuccess(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //处理选择同意&拒绝
                    let status = 1;
                    let isPayMoney = 0;
                    if(this.retreatForm.resource == "true-1"){
                        status = 2;
                        isPayMoney = 1
                    }else if(this.retreatForm.resource == "true-2"){
                        status = 2;
                        isPayMoney = 0;
                    }else{
                        status = 3;
                        isPayMoney = 0;
                    }
                    this.retreatDialogVisible = false;
                    //post(`/mpp/mppagent/auditAgent`, {
                    post(`/shop/agent/auditAgent`, {
                        id: this.auditId,
                        status: status,
                        isPayMoney: isPayMoney,
                        refuseReason: this.retreatForm.desc
                    }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.getMppAgentList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                }
            });
        },
    }
};
</script>

<style lang='scss' scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.avatar {
    width: 130px;
    height: 130px;
    display: block;
}

::v-deep .el-upload--text {
    width: 130px;
    height: 130px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

::v-deep .el-range-separator {
    width: 20px;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 130px;
    height: 130px;
    line-height: 130px;
    text-align: center;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>
